<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page_title" translate>{{'SIN_are_you_sure.page_title'}}</h1>

     <p class="page-title" translate>
      {{ 'SIN_are_you_sure.all_you_need' }}
     </p>

     <p class="page-title" translate>
      {{ 'SIN_are_you_sure.you_may_apply' }}
     </p>

     <p class="page-title" translate>
      {{ 'SIN_are_you_sure.more_details' }}
      <a-link link-url="SIN_are_you_sure.more_details_link"
              alt-text="SIN_are_you_sure.more_details_link_alt"
              label='SIN_are_you_sure.more_details_link_text'>
      </a-link>.
     </p>

     <div class="btn-div">
          <div class="button-top">
            <button class="btn-next2" alt-text='SIN_are_you_sure.return_to_sin_alt' (click)="onPreviousClick()" translate>{{"SIN_are_you_sure.return_to_sin"}}</button>
          </div>

          <div class="button-bottom">
            <div><button class="btn-cancel2" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
          </div>
          
      </div>

</div>
